/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from "react";
import { useTheme } from "../../theme/ThemeContext";

export default function LookupDialog({ open, title, options, onSelect, onClose }) {
    const { theme } = useTheme();
    if (!open) return null;
    return (
        <div
            style={{
                position: "fixed", left: 0, top: 0, right: 0, bottom: 0, zIndex: 99,
                background: "rgba(30,40,60,0.07)", display: "flex", alignItems: "center", justifyContent: "center"
            }}
        >
            <div style={{
                background: "#fff",
                borderRadius: theme.cardRadius,
                boxShadow: "0 6px 30px rgba(0,0,0,.14)",
                minWidth: 270, maxWidth: "95vw",
                padding: 18
            }}>
                <div
                    style={{
                        display: "flex", justifyContent: "space-between", alignItems: "center",
                        background: theme.secondary, color: "#fff", fontWeight: 600,
                        borderTopLeftRadius: theme.cardRadius, borderTopRightRadius: theme.cardRadius,
                        padding: "9px 13px", fontSize: 16
                    }}
                >
                    <span>{title}</span>
                    <button
                        type="button"
                        style={{
                            background: "none", border: "none", color: "#fff", fontSize: 22, cursor: "pointer"
                        }}
                        onClick={onClose}
                    >&times;</button>
                </div>
                <div style={{ padding: "12px 4px 6px 4px" }}>
                    {/* Wrap options in a scrollable div */}
                    <div style={{
                        maxHeight: 240, // Adjust as needed
                        maxWidth: 400,
                        overflowY: 'auto',
                        paddingRight: 4, // Optional: to avoid scrollbar overlapping content
                    }}>
                        {options.map(opt => (
                            <button
                                key={opt.id}
                                type="button"
                                style={{
                                    background: "#f8fafc", borderRadius: 8, padding: "10px 10px", border: "none",
                                    width: "100%", textAlign: "left", marginBottom: 8,
                                    color: theme.primary, fontSize: 15, fontFamily: theme.fontFamily,
                                    cursor: "pointer", transition: "background 0.18s"
                                }}
                                onClick={() => onSelect(opt.id)}
                            >
                                {opt.name}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
